import { inject } from "@angular/core";
import { CanMatchFn, Router } from "@angular/router";
import { AuthService } from "../services";

export const adminGuestCanMatchGuard: CanMatchFn = () => {
    const authService = inject(AuthService);
    const router = inject(Router);

    if (!authService.isAdminAuthenticated()) {
        return true;
    }

    return router.createUrlTree(["/admin"]);
};
